/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {PaginatedList} from "../../models/paginator/paginated-list";
import {
    SurveyRespondentScheduledQuestionnaireModel
} from "../../models/survey-respondent-scheduled-questionnaire-model";

export interface SurveyRespondentsGetParams {
    pageNumber?: number;
    pageSize?: number;
    surveyRespondentGuid: string;
}

export function surveyRespondentScheduledQuestionnairesGet(
    http: HttpClient, rootUrl: string, params: SurveyRespondentsGetParams, headers: HttpHeaders, context?: HttpContext
): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>>> {

    const rb = new RequestBuilder(rootUrl, surveyRespondentScheduledQuestionnairesGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.pageNumber) {
        rb.query('pageNumber', params.pageNumber)
    }
    if (params.pageSize) {
        rb.query('pageSize', params.pageSize)
    }

    rb.path('surveyRespondentGuid', params.surveyRespondentGuid, {"style":"simple"});

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>>;
        })
    );
}

surveyRespondentScheduledQuestionnairesGet.PATH = '/api/v1/survey-respondents/{surveyRespondentGuid}/scheduled-questionnaires';
